import {
  GoalCategory,
  GoalToCreate,
  TemplateLibrary,
  UserSurveyPrimaryFunction,
  UserSurveyRole,
} from 'Generated/graphql-types'
import { needsAssessment } from 'Modules/Analytics/trackActionInterface/Account/needsAssessment'
import { ConfidenceLevel, TemplateLibraryMap } from './types'
import { NeedsAssessmentWizardStep } from './constants'

export const createTemplateLibraryIdMap = (
  templateLibrary: TemplateLibrary[] = []
) => {
  const templateLibraryMap: TemplateLibraryMap = {}

  templateLibrary
    .filter((t) => t.showInListing)
    .forEach((template) => {
      const { goalTemplate, id: templateLibraryId } = template

      goalTemplate.forEach((goal) => {
        const { category, title } = goal
        if (templateLibraryId && category) {
          templateLibraryMap[templateLibraryId] = {
            templateLibraryId,
            title,
          }
        }
      })
    })

  return templateLibraryMap
}

export const sendPriorityCompletedEvent = ({
  nonprofitOrgId,
  priority,
  userEmail,
  userId,
  userPrimaryFunction,
  userRole,
}: {
  nonprofitOrgId: number
  priority: {
    rank: number
    category: GoalCategory
    confidenceLevel: ConfidenceLevel
    challenges: string
    selectedGoals: GoalToCreate[]
    customPriorities?: string
  }
  userEmail: string
  userId: number
  userPrimaryFunction: UserSurveyPrimaryFunction | undefined
  userRole: UserSurveyRole | undefined
}) => {
  const priorityData = {
    category: priority.category,
    confidenceLevel: Number(priority.confidenceLevel),
    challenges: priority.challenges,
    customPriorities: priority.customPriorities,
    nestedTopics: priority.selectedGoals.map((goal) => goal.label),
    nonprofitOrgId,
    rank: priority.rank,
    userEmail,
    userId,
    userPrimaryFunction,
    userRole,
  }
  analytics.track(
    `NA_Survey_Priority_${priority.rank}_Completed`,
    needsAssessment.Priority_Completed.Priority_Completed(priorityData)
  )
}

export const sendStepTransitionEvent = ({
  currentStep,
  nextStep,
  userId,
  nonprofitOrgId,
  funderOrgId,
  userEmail,
  userPrimaryFunction,
  userJourneyLength,
  userRole,
  didCreateGoals,
  didInviteTeamMembers,
}: {
  currentStep: NeedsAssessmentWizardStep
  nextStep: NeedsAssessmentWizardStep
  userId: number
  nonprofitOrgId: number
  funderOrgId: number | null
  userEmail: string
  userPrimaryFunction: UserSurveyPrimaryFunction | undefined
  userJourneyLength: number
  userRole: UserSurveyRole | undefined
  didCreateGoals?: boolean
  didInviteTeamMembers?: boolean
}) => {
  const stepTransitionData = {
    userId,
    nonprofitOrgId,
    funderOrgId,
    userEmail,
    currentStep,
    nextStep,
    userPrimaryFunction,
    userJourneyLength,
    userRole,
    didCreateGoals,
    didInviteTeamMembers,
  }

  analytics.track(
    `NA_Survey_${stepTransitionData.currentStep}_Step_Transition`,
    needsAssessment.NA_Survey_Step_Transition.NA_Survey_Step_Transition(
      stepTransitionData
    )
  )
}
